import {MDBInput} from "mdb-react-ui-kit";
import {Button, Image} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {postData} from "../../network/network";
import {AxiosError} from "axios";

type ResetPassword = {
    id: number
    username: string
    requested_at: number
}

export const ResetPassword = () => {
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [conformPassword, setConfirmPassword] = React.useState("");
    const location = useLocation()
    const navigate = useNavigate()
    const [data, setData] = React.useState<string>('')
    useEffect(() => {
        try {
            const params = new URLSearchParams(location.search);
            const data: ResetPassword = JSON.parse(atob(params.get('data') ?? ''));
            if (data.requested_at) {
                const time = Date.now() - data.requested_at
                if (time < 130 * 60 * 1000) {
                    setData(params.get('data') ?? '')
                }
            }
        } catch (e) {
            console.log(e)
        }

    }, []);
   const onSubmitClick = () => {
       if (data.length === 0) {
           setError('Link Expired')
           return
       }
       if (password.length === 0) {
           setError('Password should not be empty')
           return
       }
       if (conformPassword.length === 0) {
           setError('Confirm Password should not be empty')
           return
       }
       if (password !== conformPassword) {
           setError('password and conform password should be same')
           return
       }
       postData({
           url: '/api/users/set-new-password',
           data: {
               "data": data,
               "password": password,
           },
           onSuccess: () => {
               navigate('/login')
           },
           onError: (err: AxiosError) => {
               setError(`${err?.response?.data}`)
               setLoading(false)
           }
       })
       setLoading(true)
   }
    return (
        <div className="container-fluid">
            <div className="vh-100 row justify-content-center align-items-center">
                <div className="col-md-9 col-lg-6 col-xl-5">
                    <Image src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
                           fluid/>
                </div>
                <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
                    <div className="d-flex flex-column justify-content-center align-content-center">
                        {
                            data.length ?
                                <>
                                    <h2 className="fw-bold mb-3 text-center mt-5">Forget Password?</h2>
                                    <div className="mb-3">
                                        <MDBInput
                                            type="password"
                                            className="form-control form-control-lg"
                                            id="password"
                                            value={password}
                                            label="Enter Password"
                                            onChange={(ev: any) => setPassword(ev.target.value)}/>
                                    </div>
                                    <div className="mb-3">
                                        <MDBInput
                                            type="password"
                                            className="form-control form-control-lg"
                                            id="confirmPassword"
                                            value={conformPassword}
                                            label="Confirm Password"
                                            onChange={(ev: any) => setConfirmPassword(ev.target.value)}/>
                                    </div>
                                    <div className="d-flex">
                                        {isLoading ?
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            : <Button onClick={() => {
                                                onSubmitClick()
                                            }}>Submit</Button>}
                                        <label className='ms-2 mt-2'>{error}</label>
                                    </div>
                                </> : <h2 className="fw-bold mb-3 text-center mt-5">Link Expired</h2>
                        }
                    </div>
                </div>
            </div>
        </div>

    )
}